var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m81.56,38.3c3.7-.27,10.03.15,11.92.29v-13.4c-12.31-1.97-21.68-.36-27.84,4.79-5.51,4.61-8.37,12.12-8.51,22.32v.5h-12.75v14.98h12.75v38.19h14.11v-38.19h16.61l1.72-14.98h-18.3l-.03-.48c-.48-8.28,3.38-13.52,10.32-14.02Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m120.51,70.92v43.75H16.49v-43.75H1.98v58.25h133.04v-58.25h-14.51Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.98,1.83v55.66h14.51V16.33h104.02v41.15h14.51V1.83H1.98Z",
    style: {
      fill: "#d65e38"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookOrange);
export default __webpack_public_path__ + "static/media/Facebook.Orange.c1b944617d33557e3c12bb72e9e34694.svg";
export { ForwardRef as ReactComponent };